export default "__VITE_ASSET__aae25ba1__"